























































import Vue from 'vue'
import ReorderTooltip from '@/common/components/ReorderTooltip.vue'
import {
  ProductState,
  ProductEstimate
} from '@/product/types'
import { priceFormatter } from '@/common/utils'
import { formatOneDecimal } from '@/common/utils/common'

type CellData = {
  value: string | number
  align?: 'left' | 'right'
  showReorderTooltip?: boolean
}
export default Vue.extend({
  components: {
    ReorderTooltip
  },
  computed: {
    headers(): CellData[] {
      return [
        {
          value: '種別',
          align: 'left'
        },
        {
          value: '品目',
          align: 'left'
        },
        {
          value: '単価(税込)',
          align: 'right'
        },
        {
          value: '点数',
          align: 'right'
        },
        {
          value: '合計金額(税込)',
          align: 'right'
        }

      ]
    },
    storeState(): ProductState {
      return this.$store.state
    },
    estimate(): ProductEstimate {
      return this.storeState.estimate
    },
    isOrderPlainProduct(): boolean {
      return this.$store.getters.isOrderPlainProduct
    },
    quantity(): string | number {
      return formatOneDecimal(this.estimate.quantity) || 0
    },
    plateChargeAmount(): number {
      return this.quantity === 0 ? 0 : this.estimate.plateChargeTaxIncluded
    },
    addonRecord(): CellData[] | null {
      if (this.$store.getters.addonProductPsi) {
        return [
          { value: 'オプション', align: 'left' },
          { value: this.storeState.estimate.selectedAddonProductName || '', align: 'left' },
          { value: priceFormatter(this.estimate.addonProductUnitPriceTaxIncluded), align: 'right' },
          { value: this.quantity, align: 'right' },
          { value: priceFormatter(this.estimate.addonPriceTaxIncluded), align: 'right' }
        ]
      }
      return null
    },
    additionalOptionRecords(): CellData[][] | null {
      if (this.storeState.estimate.options.length) {
        return this.storeState.estimate.options.map(item => [
          { value: 'オプション', align: 'left' },
          { value: item.displayName, align: 'left' },
          { value: priceFormatter(item.priceTaxIncluded), align: 'right' },
          { value: this.quantity, align: 'right' },
          { value: priceFormatter(item.totalPriceTaxIncluded), align: 'right' }
        ])
      }
      return null
    },
    colorPatternRecord(): CellData[] | null {
      if (!this.isOrderPlainProduct) {
        return [
          { value: '印刷・刺繍', align: 'left' },
          { value: this.estimate.selectedColorPattern.colorPattern.displayName, align: 'left' },
          { value: priceFormatter(this.estimate.unitPriceTaxIncluded), align: 'right' },
          { value: this.quantity, align: 'right' },
          { value: priceFormatter(this.estimate.printingPriceTaxIncluded), align: 'right' }
        ]
      }
      return null
    },
    plateChargeRecord(): CellData[] | null {
      if (!this.isOrderPlainProduct) {
        return [
          { value: '印刷・刺繍', align: 'left' },
          { value: this.estimate.selectedColorPattern.colorPattern.displayName + 'の版代／型代', align: 'left', showReorderTooltip: true },
          { value: priceFormatter(this.estimate.plateChargeTaxIncluded), align: 'right' },
          { value: this.quantity === 0 ? 0 : 1, align: 'right' },
          { value: priceFormatter(this.plateChargeAmount), align: 'right' }
        ]
      }
      return null
    },
    fastShippingRecord(): CellData[] | null {
      if (this.$store.getters.isFastShippingSelected) {
        return [
          { value: '追加費用', align: 'left' },
          { value: '当日・翌日出荷費用', align: 'left' },
          { value: priceFormatter(this.estimate.fastShippingUnitFeeTaxIncluded), align: 'right' },
          { value: this.quantity, align: 'right' },
          { value: priceFormatter(this.estimate.fastShippingFeeTaxIncluded), align: 'right' }
        ]
      }
      return null
    },
    shippingRecord(): CellData[] {
      return [
        { value: '配送', align: 'left' },
        { value: '配送料は全国どこでも1箇所無料です', align: 'left' },
        { value: '¥0', align: 'right' },
        { value: 1, align: 'right' },
        { value: '¥0', align: 'right' }
      ]
    },
    billRecords(): CellData[][] {
      let result: CellData[][]  = [
        [
          { value: '本体', align: 'left' },
          { value: this.storeState.productDetail?.product?.displayName || '', align: 'left' },
          { value: priceFormatter(this.estimate.productUnitPriceTaxIncluded), align: 'right' },
          { value: this.quantity, align: 'right' },
          { value: priceFormatter(this.estimate.productPriceTaxIncluded), align: 'right' }
        ]
      ]
      if (this.addonRecord) {
        result.push(this.addonRecord)
      }
      if (this.additionalOptionRecords) {
        result = [...result, ...this.additionalOptionRecords]
      }
      if (this.colorPatternRecord) {
        result.push(this.colorPatternRecord)
      }
      if (this.plateChargeRecord) {
        result.push(this.plateChargeRecord)
      }
      if (this.fastShippingRecord) {
        result.push(this.fastShippingRecord)
      }
      result.push(this.shippingRecord)
      return result
    }
  }
})
